import { render, staticRenderFns } from "./MyExam.vue?vue&type=template&id=2db283b7&scoped=true&"
import script from "./MyExam.vue?vue&type=script&lang=js&"
export * from "./MyExam.vue?vue&type=script&lang=js&"
import style0 from "./MyExam.vue?vue&type=style&index=0&id=2db283b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db283b7",
  null
  
)

export default component.exports